export const environment = {
    url: "https://api-cd.policystreet.app/api",
};
